import React from "react";
import { IoMdClose } from "react-icons/io";
import { renderImage } from "../../../shopping/common/function/shopping";
import { calcPrice } from "../../../shopping/common/function/shopping";
import { CartListContainer } from "../styled/setting";

const Cart = ({ cart, setSelection, handleQtyChange, handleDelete }) => {
  return (
    <CartListContainer>
      {cart.map((item, index) => (
        <li key={item.id} className="it">
          <button className="rm" onClick={() => handleDelete(index)}>
            <IoMdClose />
          </button>
          <div className="img">{renderImage(item)}</div>
          <div className="ct">
            <span className="nm">{item.productName}</span>
            {Array.isArray(item.options) && item.options.length > 0 && (
              <>
                <span className="opt">
                  {item.options
                    .map(
                      (opt) =>
                        `${opt.name}${opt.price > 0 ? `(+${formatNumber(opt.price)}원)` : ""}`,
                    )
                    .join(" · ")}
                </span>
                <button className="optBtn" onClick={() => setSelection({ ...item, index })}>
                  옵션 변경
                </button>
              </>
            )}
            <div className="meta">
              <div className="qty">
                <button className="qtyBtn" onClick={() => handleQtyChange(index, -1)}>
                  -
                </button>
                <span className="qtyVal">{item.quantity}</span>
                <button className="qtyBtn" onClick={() => handleQtyChange(index, 1)}>
                  +
                </button>
              </div>
              <span className="price">{formatNumber(calcPrice(item))}원</span>
            </div>
          </div>
        </li>
      ))}
    </CartListContainer>
  );
};

export default Cart;
